import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleHero from './components/ArticleHero';
import ArticleBody from './components/ArticleBody';
import RelatedPosts from './components/RelatedPosts';
import BottomCTA from '@/pages/blog/components/BottomCTA';
import { blogPostingJsonLd } from '@/components/feature/BlogPostingJsonLd';

const jsonLd = blogPostingJsonLd({
  headline: 'Stretch Tent Rental Guide: Tips & Considerations for Your Event',
  description: 'Everything you need to know before renting a stretch tent, from sizing and anchoring to weather considerations, permits, and working with your supplier.',
  url: `${import.meta.env.VITE_SITE_URL || 'https://popprotents.com'}/blog/stretch-tent-rentals-guide-tips-considerations`,
  datePublished: '2026-01-30',
  dateModified: '2026-06-29',
  authorName: 'Pop Pro Tents Team',
  keywords: ['stretch tent rental', 'tent rental guide', 'event tent tips', 'renting a tent', 'outdoor event shelter'],
});

export default function StretchTentRentalGuidePage() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <ArticleHero />
        <ArticleBody />
        <RelatedPosts />
        <BottomCTA />
      </main>
      <Footer />
    </div>
  );
}